//MSMEYBListComponent
//TODO 
//Increase paidRead field in myBooks collection 
//Add Record into Wallet collection
//Add Record into Invoice / MyOrder collection 
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Tooltip from '../../components/utils/Tooltip';
import BookEarningCalculator from '../learning/BookEarningCalculator';

import MLMButtonWithCount from '../learning/MLMButtonWithCount';
import MultiLevelReferralTable from '../learning/MultiLevelReferralTable';
import { GeneratePageTopupCode} from '../../components/GenerateThink5whysCode';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBook, faPlay, faTimes, faBookOpen, faGifts, faTv, faUserFriends, faUserPlus, faUserTie, 
  faUsers, faStop, faComment, faBarChart, faDiagramProject, faUserClock, faFileInvoiceDollar, 
  faUser
} from '@fortawesome/free-solid-svg-icons';
import '../learning/styles/BookShelfListComponent.css';
import '../learning/styles/ThinkleticsTables.css';

import Speech from "speak-tts";
// import adImage from '../../assets/pageimages/bookshelflistad.png';

const MSMEYBListComponent = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();

    const [userId, setUserId] = useState(authState.user._id);
    const [ownerId, setownerId] = useState(authState.user._id);
    const [ownerName, setOwnerName] = useState(authState.user.name);
    const [myUserCode, setMyUserCode] = useState(authState.user.think5whyscode);
    const [userName, setUserName] = useState(authState.user.name);

    const [userLevel, setUserLevel] = useState(0);
    const [atLevel, setAtLevel] = useState(0);

    const [bookId, setBookId] = useState(null);
    const [myBooks, setMyBooks] = useState([]);
    const [numberOfBooks, setNumberOfBooks] = useState([]);

    const [readLogs, setReadLogs] = useState([]);
    const [fetchData, { loading }] = useFetch();
    const [selectedBookId, setSelectedBookId] = useState(null);
    const [selectedReferralBookId, setSelectedReferralBookId] = useState(null);
    const [selectedLangCode, setSelectedLangCode] = useState('en-US');

    const [selectedLog, setSelectedLog] = useState(null);
    const [readLogsClicked, setReadLogsClicked] = useState(false);

    const [speechPrefClicked, setSpeechPrefClicked] = useState(false);
    const [speechPref, setSpeechPref] = useState(false);
    const [flyOnTheWall, setFlyOnTheWall] = useState(false);
    const [expandedDates, setExpandedDates] = useState([]);
    const [myReferralsList, setMyReferralsList] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(0);
    const [myReferralsCount, setMyReferralsCount] = useState(0);
    const [downTheLineGetAllCountClicked, setDownTheLineGetAllCountClicked] = useState(false);
    const [downTheLineGetYTDCountClicked, setDownTheLineGetYTDCountClicked] = useState(false);
    const [downTheLineGetMTDCountClicked, setDownTheLineGetMTDCountClicked] = useState(false);
    const [downTheLineGetLastSevenDaysCountClicked, setDownTheLineGetLastSevenDaysCountClicked] = useState(false);
    const [downTheLineGetTodayCountClicked, setDownTheLineGetTodayCountClicked] = useState(false);
    const [downTheLineGetCustomCountClicked, setDownTheLineGetCustomCountClicked] = useState(false);
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);
    const [selectedThumbBook, setSelectedThumbBook] = useState(null);
    const [pagesReadCount, setPagesReadCount] = useState(0);
    const [increasePageRead, setIncreasePageRead] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState(59);
    const [walletBalanceAmount, setWalletBalanceAmount] = useState(0.00);
    const [walletBuyingClicked, setWalletBuyingClicked] = useState(false);
    const [walletLastUpdated, setWalletLastUpdated] = useState();
    const [walletLastUpdatedRemarks, setWalletLastUpdatedRemarks] = useState('');
    const [orderNumber, setOrderNumber] = useState(GeneratePageTopupCode());
    const [invoice, setInvoice] = useState(GeneratePageTopupCode());
    const [paymentMode, setPaymentMode] = useState('Online');
    const [insufficientBalance, setInsufficientBalance] = useState(false);
    const [customerName, setCustomerName] = useState(authState.user.name);
    const [purchaseDate, setPurchaseDate] = useState(new Date());
    const [qty, setQty] = useState(1);

    const [downTheLineGetCount, setDownTheLineGetCount] = useState({
        l1: { count: 0, totalCom: 0 },
        l2: { count: 0, totalCom: 0 },
        l3: { count: 0, totalCom: 0 },
        l4: { count: 0, totalCom: 0 },
        l5: { count: 0, totalCom: 0 },
        l6: { count: 0, totalCom: 0 },
        l7: { count: 0, totalCom: 0 },
        l8: { count: 0, totalCom: 0 }
    });
    
    const languageOptions = [
      { code: "en-US", name: "English (United States)" },
      { code: "en-GB", name: "English (United Kingdom)" },
      { code: "en-AU", name: "English (Australia)" },
      { code: "en-CA", name: "English (Canada)" },
      { code: "fr-FR", name: "French (France)" },
      { code: "fr-CA", name: "French (Canada)" },
      { code: "es-ES", name: "Spanish (Spain)" },
      { code: "es-MX", name: "Spanish (Mexico)" },
      { code: "de-DE", name: "German (Germany)" },
      { code: "it-IT", name: "Italian (Italy)" },
      { code: "pt-BR", name: "Portuguese (Brazil)" },
      { code: "pt-PT", name: "Portuguese (Portugal)" },
      { code: "ru-RU", name: "Russian (Russia)" },
      { code: "ja-JP", name: "Japanese (Japan)" },
      { code: "zh-CN", name: "Chinese (Simplified, China)" },
      { code: "zh-TW", name: "Chinese (Traditional, Taiwan)" },
      { code: "ko-KR", name: "Korean (South Korea)" },
      { code: "nl-NL", name: "Dutch (Netherlands)" },
      { code: "sv-SE", name: "Swedish (Sweden)" },
      { code: "no-NO", name: "Norwegian (Norway)" },
      { code: "da-DK", name: "Danish (Denmark)" },
      { code: "fi-FI", name: "Finnish (Finland)" },
      { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
      { code: "hi-IN", name: "Hindi (India)" },
      { code: "bn-BD", name: "Bengali (Bangladesh)" },
      { code: "ta-IN", name: "Tamil (India)" },
      { code: "te-IN", name: "Telugu (India)" },
      { code: "ur-PK", name: "Urdu (Pakistan)" },
      { code: "tr-TR", name: "Turkish (Turkey)" },
      { code: "el-GR", name: "Greek (Greece)" },
    ];
  
    const [showTree, setShowTree] = useState(false);
    const [tree, setTree] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [showTable, setShowTable] = useState(false);
    const [postCommentClicked, setPostCommentClicked] = useState(false);
    const [postedComment, setPostedComment] = useState(false);
    const [postedCommentMsg, setPostedCommentMsg] = useState("");
    const [postMyCommentClicked, setPostMyCommentClicked] = useState(false);
    const [commentListFetched, setCommentListFetched] = useState(false);
    const [commentData, setCommentData] = useState([]);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [bookIdForComment, setBookIdForComment] = useState("");
    const [bookTitleForComment, setBookTitleForComment] = useState("");
    const [bookUserIdForComment, setBookUserIdForComment] = useState("");
    const [userCommentTitle, setUserCommentTitle] = useState("");
    const [userCommentDetails, setUserCommentDetails] = useState("");
    const [isVisibleToAllChecked, setIsVisibleToAllChecked] = useState(false);
    const [postToBeDisabled, setPostToBeDisabled] = useState(false);
    const [readCommentClicked, setReadCommentClicked] = useState(false);
    const [postCloseClicked, setPostCloseClicked] = useState(false);
    const [readCommentCloseClicked, setReadCommentCloseClicked] = useState(false);
    const [isImportantChecked, setIsImportantChecked] = useState(false);
    const [errors, setErrors] = useState();
    const [myPageWalletCount, setMyPageWalletCount] = useState(0);
    const [myAllPageReadCount, setMyAllPageReadCount] = useState(0);
    const [myAllBookPageCount, setMyAllBookPageCount] = useState(0);

const fetchMyBooks = useCallback(() => {
    const config = {
        url: "/mybooks/mymsmeyb",
        method: "post",
        headers: { Authorization: authState.token },
        data: {userId: userId}
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response && Array.isArray(response.mybooks)) {
                setMyBooks(response.mybooks);
                setNumberOfBooks(myBooks.length);
            } else {
                console.error("Invalid response format: Book not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching MyBooks:", error);
        });
  }, [authState.token, fetchData]);


  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMyBooks();
  }, [authState.isLoggedIn, fetchMyBooks]);

    const formatDate = (date) => {
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const formatReadTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds}`;
    };

    const handleReadClick = (bookCode, bookMasterId, bookCollectionName, lastPageRead, bookPages, bookIsChildren) => {
      
      navigate('/readmsmeybbook', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
    };

    const [viewReadLogClicked, setViewReadLogClicked] = useState(false);
    const handleReadLogClick = (bookId) => {
        setSelectedBookId(prev => (prev === bookId ? null : bookId));
        fetchReadingLog(bookId);
    };

    useEffect(() => {
        // Fetch reading log when selected book changes
    }, [selectedBookId]);

    const [viewNotes, setViewNotes] = useState(false);
    const handleViewNotesClick = (bookId) => {
      setSelectedBookId(prev => (prev === bookId ? null : bookId));
      setViewNotes(true);
      setPagesReadCount(readLogs.length);
      if(viewReadLogClicked && readLogs.length<1) {
        fetchReadingLog(bookId);
      }
    };

  const [instantReferralViewClicked,setInstantReferralViewClicked]=useState(false);
  const [myBBList,setMyBBList]=useState(false);
  const [numberOfBB,setNumberOfBB]=useState(0);

  const handleInstantReferralsListClick = (bookId) => {
    setInstantReferralViewClicked(!instantReferralViewClicked);
    if(!instantReferralViewClicked) {
      return;
    }
    if(numberOfBB < 1)
    {
      fetchMyInstantReferral(bookId);
    }
  };

  const fetchMyInstantReferral = useCallback((bookId) => {
    const config = {
        url: "/mybooks/mybblist",
        method: "post",
        headers: { Authorization: authState.token },
        data: {bookId: bookId, bbId: userId}
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response && Array.isArray(response.myBBList)) {
                setMyBBList(response.myBBList);
                setNumberOfBB(myBBList.length);
            } else {
                console.error("Invalid response format: Book not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching MyBooks:", error);
        });
  }, [authState.token, fetchData]);


  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMyInstantReferral();
  }, [authState.isLoggedIn, fetchMyInstantReferral]);


const [viewBillClicked,setViewBillClicked]=useState(false);
const [myInvoice,setMyInvoice]=useState('');

const handleViewBillClick = (mybookId) => {
  setViewBillClicked(prev => !prev);
  
  // Fetch the invoice if it's not already fetched
  if (!myInvoice) {
    fetchMyInvoice(mybookId);
  }
};

const fetchMyInvoice = useCallback((mybookId) => {
  const config = {
      url: "/myorders/invoice",
      method: "post",
      headers: { Authorization: authState.token },
      data: { bookId: mybookId, userId: userId }
  };

  fetchData(config, { showSuccessToast: false })
      .then(response => {
          if (response && response.myInvoice) {
              // console.log("Invoice response: ", response.myInvoice.invoice);
              setMyInvoice(response.myInvoice);  // Ensure response.myinvoice exists
          } else {
              setMyInvoice('');  // Reset state if no invoice
              console.error("Invalid response format: Invoice not found in response");
          }
      })
      .catch(error => {
          setMyInvoice('');  // Handle errors by resetting state
          console.error("Error fetching invoice:", error);
      });
}, [authState.token, fetchData, userId]);


// useEffect(() => {
//     if (!authState.isLoggedIn) return;
//     fetchMyInvoice();
// }, [authState.isLoggedIn, fetchMyInvoice]);

    const handleFlyOnTheWallClick = (bookId, bookTitle) => {
        navigate('/flyonwall/add', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, flyerOnTheWallId: null, flyerOnTheWallName: null } });
    };

    const handleFlyerOnTheWallListClick = (bookId, bookTitle) => {
        navigate('/flyersonthewall', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const handleIAmFlyingOnTheWallClick = (bookId, bookTitle) => {
      navigate('/iamflying', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const handleDcrClick = (bookId, bookTitle) => {
        navigate('/dcr/add', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, coReaderId: null, coReaderName: null } });
    };

    const handleDcrListClick = (bookId, bookTitle) => {
        navigate('/dcrlist', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const handleMentorsListClick = (bookId, bookTitle) => {
    };

    const handleAddMentorClick = (bookId, bookTitle) => {
    };

    const handleIAmMentoringClick = (bookId, bookTitle) => {
    };

    const fetchReadingLog = useCallback((bookId) => {
        setBookId(bookId);
        const config = {
            url: "/myreadinglog",
            method: "get",
            headers: { Authorization: authState.token },
            params: { bookId: bookId, userId: userId }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response)) {
                    setReadLogs(response);
                    setSelectedLog(bookId);
                    setViewReadLogClicked(true);
                    setPagesReadCount(response.length);
                } else {
                    console.error("Invalid response format: Book reading log not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching BooksReadingLog:", error);
            });
    }, [authState.token, fetchData, userId, bookId]);

    useEffect(() => {
        fetchReadingLog(bookId);
    }, [fetchReadingLog, setReadLogs]);


    useEffect(() => {

    }, [readLogs, bookId], selectedLog);

    const [showReferralsList, setShowReferralsList] = useState(false);

    const handleMyReferralsListClick = (bookId, myUserCode, userLevel) => {
        setSelectedReferralBookId(prev => (prev === bookId ? null : bookId));
        setShowReferralsList(!showReferralsList);
        fetchMyReferralsList(bookId, myUserCode, userLevel);
    };

    const fetchMyReferralsList = useCallback((bookId, myUserCode, userLevel) => {
        setBookId(bookId);
        setMyUserCode(myUserCode);
        setUserLevel(userLevel);
        const config = {
            url: "/mybooks/myreferralslist",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: bookId, advisorCode: myUserCode, userLevel: userLevel, userCode: myUserCode }
        };

        fetchData(config)
            .then(response => {
                if (response && response.referralsList && Array.isArray(response.referralsList)) {
                    setMyReferralsList(response.referralsList);
                } else {
                    console.error("Invalid response format: Referral List not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral List:", error);
            });
    }, [authState.token, fetchData, userId, bookId]);

    useEffect(() => {
  
    }, [fetchMyReferralsList, setMyReferralsList]);

    const fetchMyReferralsCount = useCallback((bookId, myUserCode, userLevel, atLevel) => {
        setBookId(bookId);
        setMyUserCode(myUserCode);
        setAtLevel(atLevel);
        const config = {
            url: "/mybooks/myreferralscount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: bookId, advisorCode: myUserCode, userLevel: userLevel, atLevel: atLevel }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response) {
                    setMyReferralsCount(response.referralsCount);
                    setSelectedLevel(atLevel);
                } else {
                    console.error("Invalid response format: Referral Count not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral Count:", error);
            });
    }, [authState.token, fetchData, userId, bookId, myUserCode, userLevel, atLevel]);

    useEffect(() => {

    }, [fetchMyReferralsCount, setMyReferralsCount]);


    useEffect(() => {
        //
    }, [myReferralsCount, bookId], myUserCode, atLevel, selectedLevel);

    const dateRangeType='A';
    const [fromDate, setFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [customFromDate, setCustomFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [customToDate, setCustomToDate] = useState(new Date().toISOString().split('T')[0]);

    const handleDownTheLineGetAllCount = (selectedBookId) => {
        setDownTheLineGetAllCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];;
        const toDate = new Date().toISOString().split('T')[0];;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'A', fromDate, toDate);
    };

    const handleDownTheLineGetYTDCount = (selectedBookId) => {
        setDownTheLineGetYTDCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; // Example: "2024-07-10"

        const firstDateOfYear = new Date(today.getFullYear(), 0, 1); // Month is 0-based, so 0 represents January
        const fromDate = firstDateOfYear.toISOString().split('T')[0]; // Example: "2024-01-01"
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'Y', fromDate, toDate);
    };

    const handleDownTheLineGetMTDCount = (selectedBookId) => {
        setDownTheLineGetMTDCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; // Example: "2024-07-10"

        const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const fromDate = firstDateOfMonth.toISOString().split('T')[0]; // Example: "2024-07-01"
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'M', fromDate, toDate);
    };

    const handleDownTheLineGetLastSevenDaysCount = (selectedBookId) => {
        setDownTheLineGetLastSevenDaysCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; 

        // Calculate fromDate (6 days before toDate)
        const sixDaysAgo = new Date(yesterday);
        sixDaysAgo.setDate(sixDaysAgo.getDate() - 6);
        const fromDate = sixDaysAgo.toISOString().split('T')[0]; 
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'W', fromDate, toDate);
    };

    const handleDownTheLineGetTodayCount = (selectedBookId) => {
        setDownTheLineGetTodayCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];
        const toDate = new Date().toISOString().split('T')[0];
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'T', fromDate, toDate);
    };

    const handleDownTheLineGetCustomCount = (selectedBookId) => {
        setDownTheLineGetCustomCountClicked(true);
        const fromDate = customFromDate;
        const toDate = customToDate;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'C', fromDate, toDate);
    };

    const fetchDownTheLineGetCount = useCallback((selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate) => {
        setBookId(selectedBookId);
        setMyUserCode(myUserCode);
        if (!selectedBookId || !myUserCode || !myUserId || !dateRangeType || !fromDate || !toDate) {
            return;
        }
        const config = {
            url: "/mlmchart/downthelinecount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { 
                bookId: selectedBookId, 
                userCode: myUserCode, 
                userId: myUserId, 
                dateRangeType: dateRangeType, 
                fromDate: fromDate,
                toDate: toDate 
            }
        };
        // console.log("Request Payload:", { selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate }); // Log the payload
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response from referral list endpoint: ", response);

                if (response && response.referralsCount) {
                    setDownTheLineGetCount(response.referralsCount);
                } else {
                    console.error("Invalid response format: Down The Line Referral Count not found in response");
                    setDownTheLineGetCount({
                        l1: { count: 0, totalCom: 0 },
                        l2: { count: 0, totalCom: 0 },
                        l3: { count: 0, totalCom: 0 },
                        l4: { count: 0, totalCom: 0 },
                        l5: { count: 0, totalCom: 0 },
                        l6: { count: 0, totalCom: 0 },
                        l7: { count: 0, totalCom: 0 },
                        l8: { count: 0, totalCom: 0 }
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching Down The Line  Referral Count:", error);
                setDownTheLineGetCount({
                    l1: { count: 0, totalCom: 0 },
                    l2: { count: 0, totalCom: 0 },
                    l3: { count: 0, totalCom: 0 },
                    l4: { count: 0, totalCom: 0 },
                    l5: { count: 0, totalCom: 0 },
                    l6: { count: 0, totalCom: 0 },
                    l7: { count: 0, totalCom: 0 },
                    l8: { count: 0, totalCom: 0 }
                });
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
            // fetchDownTheLineGetCount(bookId, myUserCode, userId, dateRangeType, fromDate, toDate); 
    }, [setDownTheLineGetCount, fetchDownTheLineGetCount]);

    const sortedBooks = myBooks.sort((a, b) => {
        const dateA = new Date(a.purchaseDate);
        const dateB = new Date(b.purchaseDate);
        return dateB - dateA;
    });


    const sortedLog = readLogs.sort((a, b) => {
        const dateA = new Date(a.dateRead);
        const dateB = new Date(b.dateRead);
        return dateB - dateA;
    });

    const sortedPages = readLogs.sort((a, b) => {
      const pageA = new Date(a.pageNumber);
      const pageB = new Date(b.pageNumber);
      return pageA - pageB;
  });

    const toggleDateExpansion = (date) => {
        if (expandedDates.includes(date)) {
            setExpandedDates(expandedDates.filter(item => item !== date));
        } else {
            setExpandedDates([...expandedDates, date]);
        }
    };

    const logsByDate = readLogs.reduce((acc, log) => {
        const date = log.dateRead.split('T')[0];
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(log);
        return acc;
    }, {});

  //   const logsByPageNumber = readLogs.reduce((acc, log) => {
  //     const pgn = log.pageNumber;
  //     if (!acc[date]) {
  //         acc[date] = [];
  //     }
  //     acc[date].push(log);
  //     return acc;
  // }, {});

  // Sort dates in descending order
  const sortedLogsByDate = Object.keys(logsByDate)
      .sort((a, b) => new Date(b) - new Date(a))
      .reduce((acc, date) => {
          acc[date] = logsByDate[date];
          return acc;
      }, {});

      // console.log("sortedLogsByDate ",sortedLogsByDate);

      const groupedReadLogs = readLogs.reduce((acc, log) => {
        const existingLog = acc.find(item => item.pageNumber === log.pageNumber);
        
        if (existingLog) {
          existingLog.pageCount += 1;
          existingLog.totalMilliseconds += log.readTimeInMiliseconds;
          existingLog.readingRemarks.push(log.readingRemarks); // To store multiple remarks
        } else {
          acc.push({
            pageNumber: log.pageNumber,
            pageCount: 1,
            totalMilliseconds: log.readTimeInMiliseconds,
            readingRemarks: [log.readingRemarks], // Start with the first remark
          });
        }
        
        return acc;
      }, []);

    const totalCount = Object.values(downTheLineGetCount).reduce((sum, level) => sum + level.count, 0);
    const totalCommission = Object.values(downTheLineGetCount).reduce((sum, level) => sum + parseFloat(level.totalCom), 0);

    const [showReferrals, setShowReferrals] = useState(false);

    const toggleReferralsList = () => {
      setShowReferrals(!showReferrals);
    };

  const [viewCommentClick, setViewCommentClick] = useState(false);
  const [viewCommentClickMsg, setViewCommentClickMsg] = useState('');
  // const handleViewComments = (bookId, pageNumber, userId) => {
  //   setViewCommentClick(true);
  //   setViewCommentClickMsg("You can view your annotations & other's comments for this page! We will get back to you soon with this feature.");
  //   fetchReadCommentByPageNumber()
  // }


  // const [viewComment, setViewComment] = useState(false);
  const handleViewComments = (selectedBookId, bookOwnerId, bookPageNumber) => {
    // setViewComment(true);
    setIsOverlayVisible(true);
    // setPostCommentClicked(false);
    fetchReadCommentByPageNumber(selectedBookId, bookOwnerId, bookPageNumber);
  }

  const handleCloseOverlay = () => {
    setIsOverlayVisible(false);
  };
  

  //Read Comments List
  const fetchReadCommentByPageNumber = useCallback((selectedBookId, bookOwnerId, bookPageNumber) => {
    const config = {
      url: "/myreadingnotes/notesbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: selectedBookId,
        userId: bookOwnerId,
        pageNumber: bookPageNumber
      },
    };
    // console.log("Read Comments config to server: ", config);

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        // console.log("Read Comments Response:", response);
        if (response && response.status) {
          setCommentData(response.notes);
          // console.log("setCommentData ", response.notes); // Log response.notes
        } else {
          console.error("Read Comments data not found in response");
        }
      })
      .catch((error) => {
        console.error("Error fetching Read Comments data:", error);
      });
  }, [authState.token, fetchData]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchReadCommentByPageNumber();
  }, [authState.isLoggedIn, fetchReadCommentByPageNumber]);

  const sortedCommentData = [...commentData].sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  const handlePostClose = () => {
    setPostCloseClicked(true);
    setPostCommentClicked(false);
    setPostToBeDisabled(true);
  };

  const handleReadCommentClose = () => {
    setReadCommentClicked(false);
    setReadCommentCloseClicked(true);
  };

  const gotoRCA = (bookIdForComment, bookTitleForComment, userIdForComment, pageNumber ) => {
    // console.log("I am inside gotoRCA()");
    navigate("/rcas/add");
  };

  const [isListenNotesClicked, setIsListenNotesClicked] = useState(false);
  
  const listenNotesClicked = (mynotestext) => {
    setIsListenNotesClicked(true);
    speech.cancel();
    toggleSpeechNotes(mynotestext);
  }

  const [isNotesSpeaking, setIsNotesSpeaking] = useState(false);
  const speech = new Speech();

  const toggleSpeechNotes = (mynotestext) => {
    // console.log("my notes text ",mynotestext);

    if (isNotesSpeaking) {
      speech.cancel();
      setIsNotesSpeaking(false);
    } else {
      setIsNotesSpeaking(true);
      speech.setRate(1.0);
      speech.setPitch(2.0);
      speech.setVolume(1.0);
      speech.setLanguage(selectedLangCode);
      speech.speak({ text: mynotestext });
    }
  };

  useEffect(() => {
    return () => {
      if (isNotesSpeaking) {
        speech.cancel();
        setIsNotesSpeaking(false);
      }
    };
  }, [isNotesSpeaking]);

  const handleViewGraphTimeLineClick = (graphData) => {
    navigate("/bigdata-book-readlog-timeline", { state: { graphData: graphData } });
};

const handleViewGraphPageReadCountClick = (graphData) => {
  navigate("/bigdata-book-readlog-pageread", { state: { graphData: graphData } });
};

const scrollToDetail = (bookCode) => {
  const detailElement = document.getElementById(`book-detail-${bookCode}`);
  if (detailElement) {
    detailElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    console.error(`Detail section for bookCode ${bookCode} not found.`);
  }
};

const handleIncreasePageReadClicked = () => {
  setIncreasePageRead(true);
  fetchWalletBalance();
};

//WalletBalance
const fetchWalletBalance = useCallback(() => {
  const config = {
      url: "/walletbalance",
      method: "get",
      headers: { Authorization: authState.token }
  };

  fetchData(config, { showSuccessToast: false })
      .then(response => {
          // console.log("Wallet Balance Response:", response);
          if (response) {
              // console.log("Wallet Balance Response in array:", response);
              setWalletBalanceAmount(response.balanceAmount);
              setWalletLastUpdated(response.lastTransactionDate);
              setWalletLastUpdatedRemarks(response.remarks);
          } else {
              console.error("Invalid response format: Wallet not found in response");
              setWalletBalanceAmount(0);
              setWalletLastUpdated(null);
              setWalletLastUpdatedRemarks('');
          }
      })
      .catch(error => {
          console.error("Error fetching wallet master:", error);
          setWalletBalanceAmount(0);
      });
}, [authState.token, fetchData]);

useEffect(() => {
  if (!authState.isLoggedIn) return;
  fetchWalletBalance();
}, [authState.isLoggedIn, fetchWalletBalance]);


const handleRechargeWallet = (book) => {
  navigate('/wallet-topup', { state: { bookData: book, gifterId: null, gifterName: '', giftFor: '', giftMessage: '', gifterSignatureLine: '' } });
};

const walletPaymentClicked = (orderNumber, purchaseDate, customerName, bookTitle, paymentAmount) => {
  // setNavigatedFromWalletPayment(1);
  setInvoice(`
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #ddd; padding: 20px; border-radius: 10px;">
          <h2 style="font-size: 24px; font-weight: 600; color: #333; margin-bottom: 20px; text-align: center;">Order Summary</h2>
          <div style="color: #555; line-height: 1.6;">
              <p><strong>Order Number:</strong> ${orderNumber}</p>
              <p><strong>Order Date:</strong> ${purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
              <p><strong>Customer Name:</strong> ${customerName}</p>
              <p><strong>Customer Address:</strong> Online Digital Product</p>
              <p><strong>Item:</strong> ${bookTitle}</p>
              <p><strong>Item Description:</strong> ${bookTitle}</p>
              <p><strong>HSN Code:</strong> ${'testHSN'}</p>
              <p><strong>GST Rate:</strong> ${18}</p>
              <p><strong>Qty:</strong> 1 </p>
              <p><strong>Rate:</strong> ₹${paymentAmount}</p>
              <p><strong>Bill Amount:</strong> ₹${paymentAmount}</p>
              <p><strong>Amount Paid:</strong> ₹${paymentAmount}</p>
              <p><strong>Payment Method:</strong>{'Digital through Think5Whys Prepaid Wallet'}</p>
              <p><strong>Terms & Conditions:</strong> ${''}</p>
              </div>
      </div>
  `);
  savePageTopup();
};

  // useEffect(() => {
  //   savePageTopup();
  // }, []);

  const savePageTopup = async () => {
    const currentDate = new Date();
    const requestData = {
        userId: userId,
        userCode: myUserCode,
        userName: userName,
        bookId: "686cb410235d028b14592fdd",
        bookCode: "MSMEYB",
        purchaseDate: purchaseDate,
        particulars: "400 Page Read Added",
        pageCount: 400,
        paymentAmount: paymentAmount,
        paymentMode: paymentMode,
        paymentDate: new Date(),
        dateCreated: new Date(),
        createdBy: userId,
        invoice: invoice,
        orderNumber: orderNumber,
        invoiceNumber: orderNumber,
        receiptNumber: orderNumber,
        currentStatus: "OUP",
        sellerDetails: "Think5Whys Global DeepTech Solutions",
        gstNumber: 'AF',
        hsnCode: 'TestHSN',
        gstRate: 18,
        tnc: 'Once sold can not be refunded or returned in any circumstances.',
        qty: qty,
        unit: "Pc",
        rate: paymentAmount / qty,
    };
    try {
        const config = { url: `/pagewallet/addpages`, method: "post", data: { pageTopupData: requestData}, headers: { Authorization: authState.token } };
        // console.log("pagewaalet config to save: ",config);
        await fetchData(config);
        navigate('/dashboard');
    } catch (error) {
        console.error('An error occurred while fetching data:', error);
    }
};

  return (
    <div className="flex flex-col justify-center">
      <div className="ml-2 mr-2 page-content flex flex-col justify-center items-center">
          {myBooks.length < 1 && (
            <div className="text-yellow-500 text-2xl mt-4">
              <p>You have not purchased MSME Year Book!!</p>
            </div>
          )}
      </div>
      {sortedBooks.map((book, index) => (
        <div key={book.bookCode} id={`book-detail-${book.bookCode}`} className="book-item">
          <div className="thumb-book-image-container">
            <img 
                src={`/api/bookworldthumb/${book.bookImage}.png`}
                alt={"No Image " + book.bookTitle} 
                style={{width: "100px", height: "auto"}}
            />
          </div>
          <div className="details-container mt-2">
            <p className="book-title">{book.bookTitle}</p>
          </div>
          <div className="mt-2 w-full">
            <p className='text-m'>Reading Activities </p> 
            {/* {readLogs.length} {book.paidReads} {pagesReadCount} */}
          </div>
          <div className="mb-2 w-full">
            <div className="flex justify-center mt-2 bg-purple-600 rounded-lg">
              <div className="tooltip-container w-20">
                <button
                  className="mx-1 px-2 py-1 text-white rounded bg-green-500"
                  disabled={readLogs.length > book.paidReads}
                  onClick={() =>
                    handleReadClick(
                      book.bookCode,
                      book.bookId,
                      book.bookCollectionName,
                      book.lastPageRead,
                      book.bookPages,
                      book.isChildren
                    )
                  }
                  style={{ maxWidth: "150px" }}
                >
                  <FontAwesomeIcon icon={faBookOpen} />
                </button>
                <span className="tooltip">Read</span>
              </div>
              <div className="tooltip-container ml-4 w-20">
                <button
                  className="mx-1 py-1 text-white rounded bg-green-500"
                  onClick={() => handleReadLogClick(book.bookId)}
                  style={{ maxWidth: "160px" }}
                >
                  <FontAwesomeIcon icon={faBook} />
                </button>
                <span className="tooltip">View Read Log</span>
              </div>
              <div className="tooltip-container ml-4 w-20">
                <button
                  className="mx-1 py-1 text-white rounded bg-green-500"
                  onClick={() => handleViewNotesClick(book.bookId)}
                  style={{ maxWidth: "160px" }}
                >
                  <FontAwesomeIcon icon={faComment} />
                </button>
                <span className="tooltip">View / Listen Notes</span>
              </div>
              { pagesReadCount > 0 && (
                  <div className="tooltip-container ml-4 w-20">
                    <button
                      className="mx-1 py-1 text-white rounded bg-green-500"
                      onClick={() => handleViewGraphTimeLineClick(logsByDate)}
                      style={{ maxWidth: "160px" }}
                    >
                      <FontAwesomeIcon icon={faBarChart} />
                    </button>
                    <span className="tooltip">View Graph</span>
                  </div>
              )}
            </div>
            {selectedBookId === book.bookId &&
              Object.keys(logsByDate).length > 0 &&
              book && (
                <div className='flex flex-col justify-center text-sm w-full'>
                  <div>
                    <p>
                      {book.bookTitle} has been read{" "}
                      <span className="text-green-600">
                        {readLogs.length}
                      </span>{" "}
                      times!{" "} 
                      <span className='text-blue-700'>
                        Paid Page Read Limit {book.paidReads}
                      </span>
                    </p>
                    {readLogs.length > (book.paidReads + myPageWalletCount) && (
                      <div>
                        <p className="text-red-600 text-xl mt-4">Your page read limit has been reached!!</p>
                        <p className="mx-2 mt-2 mb-2 text-m">
                          <button
                            className="text-white-800 bg-lime-600 py-2 px-4 rounded-sm"
                            onClick={handleIncreasePageReadClicked}
                          >
                            Increase 400 Page Reads
                          </button>
                        </p>
                        <p>Wallet Amount: {walletBalanceAmount}{'  Amount to be Paid: '} {paymentAmount}</p>
                        {increasePageRead? "Increase Clicked" : "Increase not clicked"}

                        <p className="mx-2 mb-4 text-m text-blue-600">
                          [INR (₹) 59.00 inclusive of all taxes]
                        </p>
                        {increasePageRead && (
                          <div className="w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-2">
                            <div className="mb-2">
                              <div className="mb-4 text-lg text-white">
                                <p>Price to pay: <span className="text-yellow-300">₹{paymentAmount.toFixed(2)}</span></p>
                                <p>Think5Whys Wallet Balance: <span className="text-yellow-300">₹{walletBalanceAmount.toFixed(2)}</span></p>
                                {paymentAmount > walletBalanceAmount ? (
                                  <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                ) : (
                                  <p className="text-white">
                                    After payment your Wallet balance will be: <span className="text-yellow-300">₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                  </p>
                                )}
                              </div>
                            </div>

                            {walletBalanceAmount < paymentAmount && (
                              <div className="mb-4 flex text-wrap justify-center">
                                <button
                                  type="button"
                                  className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                  onClick={() => handleRechargeWallet(book)}
                                >
                                  Recharge Wallet
                                </button>
                              </div>
                            )}

                            {walletBalanceAmount >= paymentAmount && (
                              <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-white max-w-md mx-auto my-4">
                                <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">Order Summary</h2>
                                <div className="space-y-2 text-gray-700">
                                  <p><strong>Order Number:</strong> {orderNumber}</p>
                                  <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                  <p><strong>Customer Name:</strong> {customerName}</p>
                                  <p><strong>Customer Address:</strong> Online Digital Product</p>
                                  <p><strong>Item:</strong> {book.bookTitle}</p>
                                  <p><strong>Item Description:</strong> MSME Year Book Increase 400 Page Reads</p>
                                  <p className="text-lg font-bold text-green-600"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                  <p className="text-lg font-bold text-green-600"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                  <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                </div>

                                <div className="flex justify-center mt-6">
                                  <button
                                    type="button"
                                    className="bg-green-800 text-white py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                    onClick={() => walletPaymentClicked(orderNumber, purchaseDate, customerName, book.bookTitle, paymentAmount)} 
                                  >
                                    Confirm Now To Buy. Your Think5Whys Wallet Will Be Charged.
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div>
                    <p className="text-sm">Time Spent in min:sec (less than 0 seconds will be shown as 0:0)</p>
                  </div>
                  <div className="text-white bg-slate-800 flex w-full text-m">
                      <p>Page Read Log</p>
                  </div>
                  <div className="text-white bg-slate-700 flex w-full text-sm">
                    <div
                      className="text-sm"
                      style={{
                        width: "30%",
                        border: "1px solid white",
                        textAlign: "left",
                        padding: "0.25rem", 
                      }}
                    >
                      Date Read
                    </div>
                    <div
                      className="text-sm"
                      style={{
                        width: "50%",
                        border: "1px solid white",
                        padding: "0.25rem", 
                      }}
                    >
                      Page
                    </div>
                    <div
                      className="text-sm"
                      style={{
                        width: "20%",
                        border: "1px solid white",
                        padding: "0.25rem", 
                      }}
                    >
                      Time Spent
                    </div>
                  </div>
                  <div className="text-black bg-blue-200 w-full text-sm">
                    {Object.entries(logsByDate).map(([date, logs]) => (
                      <div key={date}>
                        <div
                          className="text-yellow-600 text-sm"
                          onClick={() => toggleDateExpansion(date)}
                          style={{ textAlign: "left" }}
                        >
                          <span>
                            {expandedDates.includes(date) ? "-" : "+"}
                          </span>{" "}
                          {formatDate(date)}
                        </div>
                        {expandedDates.includes(date) && (
                          <div className='text-sm mt-2'>
                            {logs.map((log, index) => (
                              <div
                                key={index}
                                className="flex justify-start text-sm"
                              >
                                <div
                                  className='text-sm'
                                  style={{
                                    width: "30%",
                                    marginRight: "2px",
                                    border: "1px solid white",
                                  }}
                                >
                                  {formatDateTime(log.dateRead)}
                                </div>
                                <div
                                  style={{
                                    width: "50%",
                                    marginRight: "2px",
                                    border: "1px solid white",
                                  }}
                                >
                                  {log.readingMode==='TV' && ( <FontAwesomeIcon className="text-sm mr-2" icon={faTv}/>)}
                                  {log.readingRemarks}
                                </div>
                                <div
                                  style={{
                                    width: "20%",
                                    border: "1px solid white",
                                  }}
                                >
                                  {formatReadTime(log.readTimeInMiliseconds)}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  { viewNotes && (
                    <>
                      <div className="text-white bg-slate-800 flex w-full text-lg mt-4">
                          <p>Notes & Comments</p>
                      </div>
                      <div className="text-white bg-slate-700 flex w-full text-sm">
                        <div
                          className="text-sm"
                          style={{
                            width: "40%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Page
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Read Count
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Time Spent
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Notes
                        </div> 
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          RCA
                        </div>
                      </div>
                      <div className="text-black bg-blue-200 w-full text-sm">
                        {groupedReadLogs.map((group, index) => (
                          <div key={index} className="flex justify-start text-sm">
                            <div
                              style={{
                                width: "40%",
                                marginRight: "2px",
                                border: "1px solid white",
                              }}
                            >
                              {group.pageNumber}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                            >
                              {group.readingRemarks.length}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                            >
                              {formatReadTime(group.totalMilliseconds)}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                            >
                              <Tooltip text={"View Notes/Comments"} position={"top"}>
                                <span
                                  className="mr-1 text-blue-500 cursor-pointer"
                                  onClick={() =>
                                    handleViewComments(
                                      book.bookId,
                                      book.userId,
                                      group.pageNumber
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-comments"></i>
                                </span>
                              </Tooltip>
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                            >
                              <Tooltip text={"RCA"} position={"top"}>
                                <span
                                  className="ml-1 mr-1 text-blue-500 cursor-pointer"
                                  onClick={() =>
                                    gotoRCA(
                                      book.bookId,
                                      book.bookTitle,
                                      book.ownerId,
                                      group.pageNumber
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-question"></i>
                                </span>
                              </Tooltip>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  {isOverlayVisible && (
                    <>
                    <div className="relative inset-0 bg-gray-900 bg-opacity-100 flex justify-center items-center z-[1000[">
                      <div className="bg-black p-2 rounded-lg shadow-lg w-full max-w-4xl">
                        <button
                          className="text-red-500"
                          onClick={() => handleCloseOverlay(false)}
                        >
                          <FontAwesomeIcon icon={faTimes} />Close
                        </button>
                        {sortedCommentData.length > 0 ? (
                          sortedCommentData.map((commentItem, commentIndex) => (
                            <div
                              key={commentIndex}
                              className="mb-6 p-6 bg-white shadow-xl rounded-lg border border-gray-200 hover:shadow-2xl transition-shadow duration-300"
                            >
                              <h4 className="text-2xl font-bold text-gray-900 mb-2">
                                {commentItem.notesType}
                              </h4>
                              <p className="text-lg font-semibold text-blue-700 mb-2">
                                {commentItem.notesTitle}
                              </p>
                              <p className="text-base text-gray-700 mb-4">
                                <strong>Details:</strong>
                                <br />
                                {commentItem.notesText}
                              </p>
                              <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-600">
                                  <strong>Is Important: </strong>
                                  {commentItem.isImportant ? (
                                    <span className="text-red-600 font-semibold">Yes</span>
                                  ) : (
                                    "No"
                                  )}
                                </p>
                                <p className="text-sm text-gray-600">
                                  <strong>By: </strong>
                                  {commentItem.notesBy}
                                </p>
                              </div>
                              <p className="text-right text-sm text-gray-500 mt-4">
                                <strong>Date: </strong>
                                {formatDateTime(commentItem.dateCreated)}
                              </p>
                              <div className="flex justify-end items-center mt-4">
                                <select
                                  value={selectedLangCode}
                                  onChange={(e) => setSelectedLangCode(e.target.value)}
                                  className="ml-4 p-2 h-8 border border-gray-300 rounded"
                                >
                                  {languageOptions.map((option) => (
                                    <option key={option.code} value={option.code}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                                <button
                                  className="ml-1 mt-2 mr-4 max-w-8 max-h-8 bg-green-600 text-white"
                                  onClick={() => listenNotesClicked(commentItem.notesText)}
                                >
                                  {isNotesSpeaking ? (
                                    <FontAwesomeIcon icon={faStop} />
                                  ) : (
                                    <FontAwesomeIcon icon={faPlay} />
                                  )}
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <>
                          <div className="mt-20 mb-20 flex flex-col justify-center text-center">
                            <p className="text-lg font-medium text-orange-500">
                              There are no Notes / Comments / Remarks for this Page!
                            </p>
                            <button
                              className="absolute top-2 right-2 text-red-500"
                              onClick={() => handleCloseOverlay(false)}
                            >
                              <FontAwesomeIcon icon={faTimes} />Close
                            </button>
                          </div>
                          </>
                        )}
                      </div>
                    </div>
                    </>
                  )}
                  {viewCommentClick && (
                    <div className="flex justify-center text-yellow-600 mb-4">
                      <p>{viewCommentClickMsg}</p>
                    </div>
                  )}
                </div>
              )}
            <div>
              <p className="book-author text-blue-500"> Pages: {book.bookPages}</p>
              <p className="book-author text-purple-700">
                In BookShelf Since{" "} <strong>{formatDateTime(book.purchaseDate)}</strong>
              </p>
              <p className={`book-author ${book.lastReadingDate? "text-purple-700" : "text-brown-500" }`}>
                {book.lastReadingDate ? (
                  <>
                    Last Page Read: <strong>{book.lastPageRead}</strong>{" "}
                    On{" "}
                    <strong>
                      {formatDateTime(book.lastReadingDate)}
                    </strong>
                  </>
                ) : (
                  <strong className="text-orange-500">
                    Not Read Yet
                  </strong>
                )}
              </p>
              {book.isGifted === 1 && (
                <div className="details-container mt-4">
                  <h2 className="text-lime-500 text-lg mb-4">
                    <FontAwesomeIcon
                      icon={faGifts}
                      className="text-red-500 text-4xl"
                    />
                  </h2>
                  <p className="text-yellow-400">
                    Gifted By : <strong>{book.gifterName}</strong>
                  </p>
                  <p className="text-purple-600">
                    <strong>{book.giftMessage}</strong>
                  </p>
                  <p className="text-green-700">{book.gifterSignatureLine}</p>
                  <p className="book-author text-blue-500">{book.gifFor}</p>
                  <p className="book-author text-gray-800">
                    Gifted on : {formatDate(book.purchaseDate)}
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="mt-2 flex flex-row justify-center">
            {/* <div className="tooltip-container w-20"> */}
              <button
                className="ml-2 py-1 text-white rounded bg-purple-800"
                onClick={() =>
                  handleInstantReferralsListClick(book.bookId)
                }
              >
                <FontAwesomeIcon icon={faUserClock} />My Instant Referrals
              </button>
              {/* <span className="tooltip"></span> */}
            {/* </div>

            <div className="tooltip-container w-20"> */}
              <button
                className="ml-2 py-1 text-white rounded bg-purple-800"
                onClick={() => handleViewBillClick(book.bookId)}
              >
                <FontAwesomeIcon icon={faFileInvoiceDollar} />Bill cum Receipt
              </button>
              {/* <span className="tooltip">
                Bill cum Receipt
              </span> */}
            {/* </div> */}
          </div>
          {instantReferralViewClicked && (
            <div className="p-4">
              <p className="text-lg font-semibold text-blue-800 mb-4">My Instant Referral List for the Book</p>
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-300 shadow-md rounded-lg">
                  <thead>
                    <tr className="bg-blue-100">
                      <th className="px-4 py-2 text-left text-white">Username</th>
                      <th className="px-4 py-2 text-left text-white">Referral Bonus</th>
                      <th className="px-4 py-2 text-left text-white">Purchase Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myBBList.map((bblist, index) => (
                      <tr key={index} className="border-t">
                        <td className="px-4 py-2 text-black">{bblist.userName}</td>
                        <td className="px-4 py-2 text-black">{(bblist.paymentAmount * 0.13).toFixed(2)}</td>
                        <td className="px-4 py-2 text-black">{formatDateTime(bblist.purchaseDate)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          { viewBillClicked && (
            <div className="p-4">
              <p className="text-lg font-semibold text-blue-800 mb-4">My Bill cum Receipt</p>
              {!myInvoice.invoice ? (
                <div>
                  <p className='text-orange-500 text-lg'>Invoice Not Found!!</p>
                </div>
              ) : (
                <div
                    className="page-content ml-2 mr-2 flex items-start"
                    style={{ minHeight: "100%" }}
                    dangerouslySetInnerHTML={{ __html: myInvoice.invoice }}
                />
              )}
            </div>
          )}
          
          <div className='flex flex-row mx-4'>
            <div className="mx-1 flex flex-col details-container mt-2 justify-center items-center bg-blue-600 w-3/5 rounded-lg py-2">
              <div className="flex flex-row justify-center text-yellow-200">Flyers On The Wall</div>
              <div className='flex flex-row'>
                <div className="tooltip-container w-20">
                  <button
                    className="mx-2 py-1 text-white rounded bg-purple-800"
                    disabled={book.isCollection}
                    onClick={() =>
                      handleFlyOnTheWallClick(book.bookId, book.bookTitle)
                    }
                  >
                    <FontAwesomeIcon icon={faUserPlus} />
                  </button>
                  <span className="tooltip">Allow Fly On The Wall</span>
                </div>

                <div className="tooltip-container w-20">
                  <button
                    className="mx-2 py-1 text-white rounded bg-purple-800"
                    disabled={book.isCollection}
                    onClick={() =>
                      handleFlyerOnTheWallListClick(book.bookId, book.bookTitle)
                    }
                  >
                    <FontAwesomeIcon icon={faUserTie} />
                  </button>
                  <span className="tooltip">
                    List of My Flyers On The Wall for This Book
                  </span>
                </div>

                <div className="tooltip-container w-20">
                  <button
                    className="mx-2 py-1 text-white rounded bg-purple-800"
                    disabled={book.isCollection}
                    onClick={() =>
                      handleIAmFlyingOnTheWallClick(book.bookId, book.bookTitle)
                    }
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </button>
                  <span className="tooltip">I am Flying On The Wall</span>
                </div>
              </div>
            </div>
            <div className="mx-1 flex flex-col details-container mt-2 justify-center bg-orange-600 w-2/5 rounded-lg py-2">
              <div className="flex flex-row justify-center text-yellow-200">Digital Co-Readers</div>
              <div className='flex flex-row'>  
                <div className="tooltip-container w-20">
                  <button
                    className="py-1 text-white rounded bg-purple-800"
                    disabled={true}
                    onClick={() => handleDcrClick(book.bookId, book.bookTitle)}
                  >
                    <FontAwesomeIcon icon={faUserFriends} />
                  </button>
                  <span className="tooltip">Add Digital Co-Reader</span>
                </div>

                <div className="tooltip-container w-20">
                  <button
                    className="py-1 text-white rounded bg-purple-800"
                    disabled={true}
                    onClick={() =>
                      handleDcrListClick(book.bookId, book.bookTitle)
                    }
                  >
                    <FontAwesomeIcon icon={faUsers} />
                  </button>
                  <span className="tooltip">
                    List of My Digital Co-readers for This Book
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col details-container mt-2 justify-center bg-lime-500 rounded-lg py-2">
            <div className="flex flex-row justify-center text-yellow-200">Mentors</div>
            <div className='flex flex-row'>  
              <div className="tooltip-container w-20">
                <button
                  className="ml-2 py-1 text-white rounded bg-purple-800"
                  disabled={book.isCollection}
                  onClick={() =>
                    handleMentorsListClick(book.bookId, book.bookTitle)
                  }
                >
                  <FontAwesomeIcon icon={faUserTie} />
                </button>
                <span className="tooltip">
                  My Mentors
                </span>
              </div>

              <div className="tooltip-container w-20">
                <button
                  className="py-1 text-white rounded bg-purple-800"
                  // disabled={book.isCollection}
                  disabled={true}
                  onClick={() => handleAddMentorClick(book.bookId, book.bookTitle)}
                >
                  <FontAwesomeIcon icon={faUserFriends} />
                </button>
                <span className="tooltip">Add Mentor</span>
              </div>

              <div className="tooltip-container w-20">
                <button
                  className="py-1 text-white rounded bg-purple-800"
                  // disabled={book.isCollection}
                  disabled={true}
                  onClick={() =>
                    handleIAmMentoringClick(book.bookId, book.bookTitle)
                  }
                >
                  <FontAwesomeIcon icon={faUserFriends} />
                </button>
                <span className="tooltip">
                  I Am Mentoring
                </span>
              </div>
            </div>
          </div>

          {book.buyingMethod === "MLM" && (
            <div>
              <div>
                <div>
                  <p className="text-lg text-purple-700">
                    You are eligible for Multi Level Referral program. Under
                    this program you can earn active & passive income as per
                    following chart:{" "}
                  </p>
                </div>
                <div>
                  <button
                    className="py-1 text-white rounded bg-blue-700"
                    onClick={() => setShowTable(!showTable)}
                  >
                    Click here to see Multi-Level referral income chart
                  </button>
                  {/* {showTable && <MultiLevelReferralTable />} */}
                  {showTable && <BookEarningCalculator param={book.salesPrice} />}
                </div>
              </div>
              <div className="flex justify-center">
                <p className="text-lg text-green-600">
                  My Referrer:{" "}
                  <strong className="text-lg">{book.advisorName}</strong>
                </p>
              </div>
              <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-purple-700"
                  onClick={() => {
                    handleMyReferralsListClick(
                      book.bookId,
                      book.userCode,
                      book.userLevel
                    );
                    toggleReferralsList();
                  }}
                >
                  {showReferrals 
                    ? "Hide Referrals List"
                    : "Show Referrals List"}
                </button>
                {/* {selectedBookId}{' data book '}{} */}
                {showReferrals && (
                  <div>
                    {myReferralsList.length === 0 && selectedBookId === book.bookId ? (
                      <p className="text-red-500">
                        There is No Referral Sales Yet for the book {book.bookTitle}!!
                      </p>
                    ) : (
                      myReferralsList.map((referral, index) => (
                        <>
                        {/* <div><p>Referral List for {book.bookTitle}</p></div> */}
                        { referral.userCode !== myUserCode && (
                          <div
                            key={index}
                            className="bg-gray-300 border-b text-blue-500 ml-4 mr-4 mb-1"
                          >
                            {/* <p className='text-blue-500'>SN: {index + 1}</p> */}
                            <p className="text-blue-500">
                              {index + 1}. User: {referral.userName} (
                              {referral.userCode})
                            </p>
                            {/* <p className='text-blue-500'>User Code: {referral.userCode}</p> */}
                            <p className="text-blue-500">
                              Purchase Date:{" "}
                              {new Date(
                                referral.purchaseDate
                              ).toLocaleDateString()}
                            </p>
                            <p className="text-blue-500">
                              Purchase Price: {referral.salesPrice.toFixed(2)}
                            </p>
                            {/* <p className='text-blue-500'>Level: {referral.userLevel}</p> */}
                          </div>
                        )}
                        </>
                      ))
                    )}
                  </div>
                )}
              </div>
              <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-orange-500"
                  onClick={() => handleDownTheLineGetAllCount(book.bookId)}
                  disabled={downTheLineGetAllCountClicked}
                >
                  Show Lifetime Count
                </button>
                {downTheLineGetAllCountClicked && downTheLineGetCount && (
                  <div className="book-list-container ml-8 mt-2 text-red-800 overflow-x-auto">
                    <div className="overflow-x-auto">
                      <table className="responsive-table">
                        <thead className="bg-gray-800">
                          <tr>
                            <th className="py-3 px-4 uppercase font-semibold text-sm">
                              Level
                            </th>
                            <th className="py-3 px-4 uppercase font-semibold text-sm">
                              Members
                            </th>
                            <th className="py-3 px-4 uppercase font-semibold text-sm">
                              Commission
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-gray-700">
                          <tr>
                            <td className="py-3 px-4">Level 1</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l1.count-1}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l1.totalCom-(book.salesPrice*0.2)
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 2</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l2.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l2.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 3</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l3.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l3.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 4</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l4.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l4.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 5</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l5.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l5.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 6</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l6.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l6.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 7</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l7.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l7.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4">Level 8</td>
                            <td className="py-3 px-4">
                              {downTheLineGetCount.l8.count}
                            </td>
                            <td className="py-3 px-4">
                              {parseFloat(
                                downTheLineGetCount.l8.totalCom
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr className="bg-yellow-600">
                            <td className="py-3 px-4 font-semibold">Total</td>
                            <td className="py-3 px-4 font-semibold">
                              {totalCount-1}
                            </td>
                            <td className="py-3 px-4 font-semibold">
                              {(totalCommission-(book.salesPrice*0.2)).toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
              <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-orange-500"
                  onClick={() => handleDownTheLineGetTodayCount(book.bookId)}
                  disabled={downTheLineGetTodayCountClicked}
                >
                  Show Yesterday's Count
                </button>
                {downTheLineGetTodayCountClicked && downTheLineGetCount && (
                  <div className="mt-4">
                    <p>
                      Level 1: {downTheLineGetCount.l1.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 2: {downTheLineGetCount.l2.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 3: {downTheLineGetCount.l3.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 4: {downTheLineGetCount.l4.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 5: {downTheLineGetCount.l5.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 6: {downTheLineGetCount.l6.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 7: {downTheLineGetCount.l7.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 8: {downTheLineGetCount.l8.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                    </p>
                  </div>
                )}
              </div>
              {/* <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-orange-500"
                  onClick={() =>
                    handleDownTheLineGetLastSevenDaysCount(book.bookId)
                  }
                  disabled={true}
                >
                  Show This Week Count
                </button>
                {downTheLineGetLastSevenDaysCountClicked &&
                  downTheLineGetCount && (
                    <div className="mt-4">
                      <p>
                        Level 1: {downTheLineGetCount.l1.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(
                          2
                        )}
                      </p>
                      <p>
                        Level 2: {downTheLineGetCount.l2.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(
                          2
                        )}
                      </p>
                      <p>
                        Level 3: {downTheLineGetCount.l3.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(
                          2
                        )}
                      </p>
                      <p>
                        Level 4: {downTheLineGetCount.l4.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(
                          2
                        )}
                      </p>
                      <p>
                        Level 5: {downTheLineGetCount.l5.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(
                          2
                        )}
                      </p>
                      <p>
                        Level 6: {downTheLineGetCount.l6.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(
                          2
                        )}
                      </p>
                      <p>
                        Level 7: {downTheLineGetCount.l7.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(
                          2
                        )}
                      </p>
                      <p>
                        Level 8: {downTheLineGetCount.l8.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(
                          2
                        )}
                      </p>
                    </div>
                  )}
              </div> */}
              {/* <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-orange-500"
                  onClick={() => handleDownTheLineGetMTDCount(book.bookId)}
                  disabled={true}
                >
                  Show MTD (Month Till Date) Count
                </button>
                {downTheLineGetMTDCountClicked && downTheLineGetCount && (
                  <div className="mt-4">
                    <p>
                      Level 1: {downTheLineGetCount.l1.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 2: {downTheLineGetCount.l2.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 3: {downTheLineGetCount.l3.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 4: {downTheLineGetCount.l4.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 5: {downTheLineGetCount.l5.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 6: {downTheLineGetCount.l6.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 7: {downTheLineGetCount.l7.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 8: {downTheLineGetCount.l8.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                    </p>
                  </div>
                )}
              </div> */}
              {/* <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-orange-500"
                  onClick={() => handleDownTheLineGetYTDCount(book.bookId)}
                  disabled={true}
                >
                  Show YTD (Year Till Date) Count
                </button>
                {downTheLineGetYTDCountClicked && downTheLineGetCount && (
                  <div className="mt-4">
                    <p>
                      Level 1: {downTheLineGetCount.l1.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 2: {downTheLineGetCount.l2.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 3: {downTheLineGetCount.l3.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 4: {downTheLineGetCount.l4.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 5: {downTheLineGetCount.l5.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 6: {downTheLineGetCount.l6.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 7: {downTheLineGetCount.l7.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 8: {downTheLineGetCount.l8.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                    </p>
                  </div>
                )}
              </div> */}
              {/* <div className="mt-2 justify-center">
                <button
                  className="py-1 text-white rounded bg-orange-500"
                  onClick={() => handleDownTheLineGetCustomCount(book.bookId)}
                  disabled={true}
                >
                  Show Count For A Start to End Date
                </button>
                {downTheLineGetCustomCountClicked && downTheLineGetCount && (
                  <div className="mt-4">
                    <p>
                      Level 1: {downTheLineGetCount.l1.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 2: {downTheLineGetCount.l2.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 3: {downTheLineGetCount.l3.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 4: {downTheLineGetCount.l4.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 5: {downTheLineGetCount.l5.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 6: {downTheLineGetCount.l6.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 7: {downTheLineGetCount.l7.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                    </p>
                    <p>
                      Level 8: {downTheLineGetCount.l8.count} members, Total
                      Commission:{" "}
                      {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                    </p>
                  </div>
                )}
              </div> */}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MSMEYBListComponent;
